import { useTranslation } from "react-i18next";
import { SearchStateInterface } from "../../models/SearchInterface";

export default function ParingListHeader({ searchState={} as SearchStateInterface, toggleMonth }) {
    const { t } = useTranslation();
    return (
        <div className="pairing-list-header-container">
            <div className='header-grey header-content'>
                <h1>{t('pairingList.title')}</h1>
                <div className='sub-title'>
                    <span>{searchState.selectedDate}</span>
                    <span>{searchState.selectedBase}</span>
                    <span>{searchState.selectedEquipment}</span>
                    <span>{searchState.selectedPosition}</span>

                </div>
                <span className='new-search-link link-states' onClick={toggleMonth}>
                    List for {searchState.toSelectDate}
                </span>
            </div>
       </div>     
    );
}